function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "a"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#0cbd2a"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#5bf675"
})), React.createElement("linearGradient", {
  xlinkHref: "#a",
  id: "b",
  x1: -25.273,
  y1: 207.521,
  x2: -25.273,
  y2: 152.998,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(.9821 0 0 .9821 -1.065 3.796)"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  paintOrder: "markers stroke fill",
  transform: "translate(59.483 -145.846)"
}, React.createElement("rect", {
  ry: 14.568,
  rx: 14.568,
  y: 145.846,
  x: -59.483,
  height: 66.146,
  width: 66.146,
  fill: "url(#b)"
}), React.createElement("path", {
  d: "M-26.41 157.296a24.278 20.222 0 00-24.278 20.222 24.278 20.222 0 0011.794 17.316 27.365 20.222 0 01-4.245 5.942 23.857 20.222 0 009.86-3.874 24.278 20.222 0 006.869.838 24.278 20.222 0 0024.278-20.222 24.278 20.222 0 00-24.278-20.222z",
  fill: "#fff"
}));

var SvgMessage = function SvgMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 66.146 66.146",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message.9c20e9de.svg";
export { ForwardRef as ReactComponent };